// MatchSchulte.jsx
import React from "react";
import "../../assets/styles/Menu_Middle.css";
import banner from "../../assets/images/kv_cricket.jpg";
import Banner from "../Banner/Banner";
import Loading from "../Loading";
import Footer from "../Footer/Footer";
import HorseCard from "./HorseCard";
import MobileMenu from "../Mobilenav/MobileMenu";

const MatchSchulte = ({ cricketMatches, MatchName, loader }) => {
  return (
    <div className="Middle-wraper">
      <div className="cricket-banner">
        <img src={banner} alt="Horse Racing banner" />
      </div>
     
      <Banner />
       <MobileMenu />
      <div className="Highlights-Head">
        <h4>Highlights</h4>
      </div>
      <h4 className="bg-black text-white p-2 pl-2.5 text-[13px] font-bold">
        {MatchName}
      </h4>
      {loader ? <Loading /> : <HorseCard horseMatches={cricketMatches} />}
      <div className="footer-section">
        <Footer />
      </div>
    </div>
  );
};

export default MatchSchulte;
